import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../View/home.vue'),
        meta: {
            title: "CorpLens-Your business assistant",
            description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
        }
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "about" */ '../View/terms.vue'),
        meta: {
            title: "Lark Info-Terms of use",
            description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
        }
    },
    // {
    //     path: '/test',
    //     name: 'test',
    //     component: () => import(/* webpackChunkName: "about" */ '../View/test.vue'),
    //     meta: {
    //         title: "Lark Info-Terms of use",
    //         description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
    //     }
    // },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router